var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.602 16.015c-1.329 0-2.404-1.125-2.404-2.504 0-1.367 1.075-2.503 2.404-2.503 1.308 0 2.383 1.136 2.383 2.503 0 1.379-1.075 2.504-2.383 2.504z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.631 24.156H6.396v-2.083c1.11-1.128 2.803-3.45 4.346-3.45.68 0 1.213.462 2.022 1.202.08.074.164.15.25.227l.96.893 4.017-3.804c.95-.894 1.456-1.18 2.142-1.18 1.73 0 4.465 4.236 5.498 5.778z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 10.419v11.162C27 23.864 25.903 25 23.688 25H8.302C6.107 25 5 23.853 5 21.581V10.419C5 8.136 6.097 7 8.311 7H23.7C25.893 7 27 8.147 27 10.419zM6.736 21.646V10.467h-.004v-.113c0-.98.507-1.51 1.448-1.51h15.646c.94 0 1.438.519 1.438 1.51v11.179h.004v.113c0 .98-.507 1.51-1.448 1.51H8.174c-.94 0-1.438-.519-1.438-1.51z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLandscape);
export default __webpack_public_path__ + "static/media/Image_Landscape.e0ae025311d9dd85fb78abed744a222e.svg";
export { ForwardRef as ReactComponent };